<template>
  <div class="content">
    <div class="box">
      <p class="chinese-name">机构概况</p>
      <p class="english-name">ABOUT US</p>
      <div class="desc-content" v-html="orgDesc"></div>
    </div>
  </div>
</template>

<script>
import { getDataByContentCode } from "@/api/service.js";
export default {
  name: "desc-box",
  data() {
    return {
      orgDesc: "",
    };
  },
  created() {
    this.getOrgDesc();
  },
  methods: {
    //获取机构概况
    getOrgDesc() {
      getDataByContentCode("RES0CCF8328B69CA6C").then((res) => {
        this.orgDesc = res.data.contentHtml;
      });
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
}
.box {
  width: 1140px;
  height: 760px;
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background: #fff;
}
.chinese-name {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  top: 20px;
  position: absolute;
  z-index: 1;
  left: 50%;
  top: 45px;
  transform: translateX(-50%);
}
.english-name {
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #faf5f5;
  margin-bottom: -18px;
}
.desc-content {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3a3a3a;
  text-align: left;
  line-height: 40px;
  margin-top: 59px;
  text-indent: 2em;
  text-align: justify;
  text-justify: inter-ideograph;
}
.desc-content1 {
  margin-top: 25px;
}
.desc-title {
  margin-top: 25px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  text-align: left;
}
</style>




// WEBPACK FOOTER //
// src/components/home/institutionalOverview/siderContent01.vue